export const isLocalDev = (host: string = window.location.host): boolean => host.startsWith("localhost") || host.includes(".local");
